module.exports = __webpack_public_path__ + "static/media/Bitmap.5d0f7f93.png";